import { render, staticRenderFns } from "./NotasFinalista-Admin.vue?vue&type=template&id=a63de820&"
import script from "./NotasFinalista-Admin.vue?vue&type=script&lang=js&"
export * from "./NotasFinalista-Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports